<template>
    <admin-person-info v-if="isAdmin" />
    <customer-person-info v-else />
</template>

<script>
import AdminPersonInfo from './views/admin-person-info';
import CustomerPersonInfo from './views/customer-person-info';

export default {
    components: {
        AdminPersonInfo,
        CustomerPersonInfo,
    },
    data() {
        return {
            isAdmin: false,
        };
    },
};
</script>

<style>
body {
    background: #faf8fb;
}
</style>
